import React,{ useEffect } from 'react';
import { useContext } from 'react';
import CartContext from '../../store/cart-context';
var AppliancesListWidth,AppliancesListRight,productImgWidth,productDetailsWidth;
const MyAppliances = () => {
   if (window.innerWidth < 460) {
      AppliancesListWidth = '96vw';
      AppliancesListRight = '2vw';
      productImgWidth = '30%';
      productDetailsWidth = '70%';
   } else {
      AppliancesListWidth = '460px';
      AppliancesListRight = '20px';
      productImgWidth = '20%';
      productDetailsWidth = '80%';
   }
   const textStyle = {
      fontFamily: "SourceSansPro",
      fontWeight: '400',
      lineHeight: '1.5',
      letterSpacing: '0.00938em',
      color: '#ffff',
      fontSize: '18px',
      // paddingLeft: '12px',
      // textAlign: 'center'
      width: '100%',
      textAlign: 'center',

   }
   const myStyle = {
      position: 'absolute',
      top: '0%',
      right: '0rem',
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      justifyContent: 'space-around',
      width: '210px',
      height: '45px',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      zIndex: '10',
      backgroundColor: '#e72224',
      textAlign: 'center',
      border: '0px green solid'

   }
   const backWindow = {
      position: 'absolute',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#f8f4f57a',
      display: 'none',
      zIndex: '10'
   }
   const AppliancesList = {
      position: 'fixed',
      display: 'none',
      right: AppliancesListRight,
      top: '20px',
      height: '90vh',
      width: AppliancesListWidth,
      zIndex: '11',
      color: 'black',
      backgroundColor: '#ffffff',
      padding: '10px',
      overflow: 'auto',
      scrollbarColor: '#7c7c7c',
      scrollbarWidth: 'thin',
   }
   const headerText = {
      textAlign: 'center',
      paddingBottom: '10px',
      fontSize: '18px'
   }
   const productDiv = {
      display: 'flex',
   }
   const prices = {
      fontSize: '14px',
      textAlign: 'left',
      margin: '0',
      fontWeight: '300'
   }
   const removeText = {
      fontSize: '14px',
      textAlign: 'left',
      margin: '0',
      color: 'red',
      cursor: 'pointer'
   }
   const mainText = {
      fontSize: '14px',
      textAlign: 'left',
      fontWeight: '600',
      margin: '0'
   }
   const mainText2 = {
      fontSize: '18px',
      marginBottom: '10px',
      textAlign: 'left',
      fontWeight: '600',
      margin: '0'
   }
   const bottomBtn = {
      display: 'flex',
      width: '80%',
      paddingTop: '12px',
      paddingBottom: '11px',
   }
   const cartCount = {
      position: 'absolute',
      left: '38px',
      top: '5px',
      fontSize: '9px',
      color: '#ffffff'
   }
   const MyAppliances = () => {
      document.getElementById('backWindow').style.display = "block";
      document.getElementById('AppliancesList').style.display = "block";

      // checkout value disabled
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      let checkout_url = urlParams.get('checkout');
      if (checkout_url != null) {
         if (checkout_url == "false") {
            // proceed_checkout         
            console.log(checkout_url);
            document.getElementById("proceed_checkout").style.display = "none";
         }
      }

   }
   const DisplayHide = () => {
      document.getElementById('backWindow').style.display = "none";
      document.getElementById('AppliancesList').style.display = "none";
   }

   const cartCtx = useContext(CartContext);
   
   const noOfItemsInCart = cartCtx.items.length;
   const cartItemRemoveHandler = (id) => {
      cartCtx.removeItem(id);
      document.querySelector('#' + id + ' .addToCartBtn').classList.add('display');
      document.querySelector('#' + id + ' .removeFromCartBtn').classList.remove('display');
      for (let i in cartCtx.items) {
         document.querySelector('#' + cartCtx.items[i].category + '.icon_stable').classList.remove('selectDrawerMain');
      }
   }

   const productslist = cartCtx.items.map(item => {
      return <div key={item.id} id={item.id} style={productDiv}>
         <div style={{ width: productImgWidth,padding: '10px 15px 10px 18px' }}><img style={{ width: "75px",margin: '0px -16px' }} src={item.img} alt="OpenOven" /></div>
         <div style={{ width: productDetailsWidth,borderBottom: '1px solid #00000038',paddingTop: '12px' }}>
            <p style={mainText}>{item.text}</p>
            <p style={prices}></p>
            <p style={removeText} onClick={cartItemRemoveHandler.bind(null,item.id)}>Remove</p>
         </div>
      </div>
   });

   function downloadObjectAsJson(exportObj,exportName) {
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href",dataStr);
      // downloadAnchorNode.setAttribute("download",exportName + ".json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
   }

   var distributorURL = {
      'defaultconfig': 'https://commondatastorage.googleapis.com',
      'renosappliance': "https://www.renosappliance.com",
   }

   

   window.proceedToCheckout = () => {
      let exportObj = [];

      // console.log(window.currentDistributor, "currentDistributor")
      // console.log(distributorURL[window.currentDistributor], "distributorURL")
      // console.log(window.location.href, "distributorURL")

      // const url = window.location.href;
      // var output = url.replace(/\/$/, "");

      const exportObject = (item) => {
         return {
            sku: item.display,
            thumbnail: 'https://content.hmxmedia.com/sharp-30/img' + item.img.substring(1),
            quantity: 1
         }
      }

      for (var i = 0; i <= cartCtx.items.length - 1; i++) {
         exportObj.push(exportObject(cartCtx.items[i]));
      }

      window.globalCart = [...exportObj]
      // exportObj = JSON.stringify(exportObj);
      console.log(exportObj);
      // downloadObjectAsJson(exportObj,'orderList');
      // window.top.postMessage(exportObj,"https://commondatastorage.googleapis.com");
      // window.top.postMessage(exportObj, distributorURL[window.currentDistributor]);
      const targetURL = distributorURL[window.currentDistributor] || distributorURL['defaultconfig'];
      window.top.postMessage(exportObj, targetURL);
      // console.log(targetURL, "targetURL")
      

      //    window.$.ajax({
      //       //the url to send the data to
      //       url: "index.html",
      //       //the data to send to
      //       data: exportObj,
      //       //type. for eg: GET, POST
      //       type: "POST",
      //       //datatype expected to get in reply form server
      //       dataType: "json",
      //       //on success
      //       success: function(data){
      //           //do something after something is recieved from php
      //           alert()
      //       },
      //       //on error
      //       error: function(){
      //           //bad request
      //       }
      //   });
   }

   const ProceedChecked = () => {
      // alert("proceed");
      // const myObjStr = JSON.stringify(cartCtx.items);
      // console.log(myObjStr);
      window.proceedToCheckout();
   }

   return (
      <>
         {noOfItemsInCart > 0 && <button id="MyAppliancesBtn" style={myStyle} onClick={MyAppliances} enabled="true">

            {/* <div style= {{width: '20px'}}><span style={cartCount}>{noOfItemsInCart}</span><img style= {{width: '17px', marginLeft: '26px'}}src="./img/addToCart.png" alt="Add to Cart"/></div> */}

            <span style={textStyle}>REVIEW MY KITCHEN</span>
         </button>}

         {noOfItemsInCart > 0 && <div style={backWindow} id="backWindow" onClick={DisplayHide}></div>}
         {noOfItemsInCart > 0 &&
            <div style={AppliancesList} id="AppliancesList">
               <header style={headerText}>Your Kitchen Appliances</header>

               {productslist}

               <div style={productDiv}>
                  <div style={{ width: '20%',padding: '15px 15px 15px 0px' }}></div>
                  <div style={bottomBtn} >
                     <button style={{ backgroundColor: '#424242',color: '#ffff',fontSize: '14px',margin: '2px',textAlign: 'center',textDecoration: 'none',border: 'none',padding: '8px' }} onClick={DisplayHide}>RETURN TO KITCHEN</button>
                     {
                         ( window.currentDistributor === 'renosappliance') ?
                         <button id="proceed_checkout" style={{ backgroundColor: '#ed2208',color: '#ffff',fontSize: '14px',margin: '2px',textAlign: 'center',textDecoration: 'none',border: 'none',padding: '8px' }} onClick={ProceedChecked}>PROCEED TO CHECKOUT</button>
                         : null
                     }
                     
                  </div>
               </div>
            </div>
         }
      </>
   )
}



export default MyAppliances;
